import { render, staticRenderFns } from "./mxp.vue?vue&type=template&id=1444c4d7&scoped=true"
import script from "./mxp.vue?vue&type=script&lang=js"
export * from "./mxp.vue?vue&type=script&lang=js"
import style0 from "./mxp.vue?vue&type=style&index=0&id=1444c4d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1444c4d7",
  null
  
)

export default component.exports